import React from "react"

interface SeparatorProps {
  dashed?: boolean
  color?: string
  thickness?: number
  width?: string
  marginY?: string
  className?: string
  children?: React.ReactNode
}

const Separator: React.FC<SeparatorProps> = ({
  dashed = false,
  color = "gray-300",
  thickness = 1,
  width = "w-full",
  marginY,
  className = "",
}) => {
  const borderStyle = dashed ? "border-dashed" : "border-solid"
  return <hr className={`${borderStyle} border-t-${thickness} border-${color} ${width} ${marginY} ${className}`} />
}

export default Separator
